module.exports = __webpack_public_path__ + "mo/img/list_bg.f1cd56a6.png";